export class ProductSubscription {
    id = -1;
    product = -1;
    start = new Date();
    end?: Date;

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.product = data.product ?? -1;
        this.start = data.start ?? new Date(data.start);
        this.end = data.end ?? undefined;
        return this;
    }
}
